import TooltipButton from "components/common/Tooltip/TooltipButton";
import styles from "./index.module.scss";
import apiData from "lib/stores/apiData";
import mapData from "lib/stores/mapData";
import { RadixTooltip } from "components/common/Tooltip/RadixTooltip";
import { useSnapshot } from "valtio";

interface ColorLegendCaptionProps {
  min: number;
  max: number;
  tooltip?: string;
}

const ColorLegendCaption = ({ min, max, tooltip }: ColorLegendCaptionProps) => {
  const { activeCategory } = useSnapshot(mapData);
  const { globals, metadata } = useSnapshot(apiData);

  const renderActiveCategory = () => {
    switch (activeCategory) {
      case "prevalence":
        return "Prevalence";
      case "vulnerability":
        return "Vulnerability";
      case "gov-response":
        return "Government Response";
      default:
        return "";
    }
  };

  const getDataTip = () => {
    if (activeCategory === "prevalence") {
      return metadata.labels.prevalence_tooltip;
    }
    if (activeCategory === "vulnerability") {
      return metadata.labels.vulnerability_tooltip;
    }
    if (activeCategory === "gov-response") {
      return metadata.labels.gov_response_tooltip;
    }
  };

  return (
    <figcaption className={styles["color-legend-caption"]}>
      <span className={styles.minMax}>{activeCategory === "prevalence" ? "Low" : min}</span>
      <div className={styles.label}>
        {renderActiveCategory()}
        <span className="w-[15px] h-[15px] pointer-events-auto">
          <RadixTooltip content={getDataTip()} Trigger={TooltipButton} />
        </span>
      </div>
      <span className={styles.minMax}>{activeCategory === "prevalence" ? "High" : max}</span>
    </figcaption>
  );
};

export default ColorLegendCaption;
